/* @ngInject */
function AddToGroupsDialogController ($scope, $rootScope, $timeout, $translate, GroupService, AdminService, ToastService) {
  $scope.flags = {
    hasShowMoreButton: false,
    loadingShowMore: false,
    noResults: false,
    loading: false,
    disabledApply: true,
    skip: null,
    top: 6
  }

  $scope.selectedGroups = []
  $scope.partialGroups = []
  $scope.groupsList = []
  $scope.countGroups = 0

  $scope.groupInput = {
    search: ''
  }

  const api = {
    _errorGetDataGroups,
    _getShowMore,
    _hasMoreResults,
    _loadDataGroups,
    _successGetDataGroups,
    _mergeGroupsList,
    _checkGroupAlreadyExistsInArray,
    _checkEqualGroupId,
    _initializeGroupList,
    _handleGroupInitialSelection,
    _checkForCommonGroups,
    _selectGroup,
    _unselectGroup
  }
  this.getApi = () => api

  activate()
  function activate () {
    api._initializeGroupList()

    api._loadDataGroups($scope.groupInput.search, true)
  }

  /**
   *  @param {object} group - object of selectedGroup
   *  @description this method handles checkbox selection and group seletion.
   */
  $scope.handleItemClick = group => {
    const isSelected = $scope.selectedGroups.includes(group.id)
    const isPartial = $scope.partialGroups.includes(group.id)

    if (isPartial || !isSelected) {
      api._selectGroup(group, isPartial)
    } else {
      api._unselectGroup(group)
    }

    $scope.flags.disabledApply = false
  }

  $scope.closeModal = () => {
    $scope.close()
  }

  /**
   *  @description this method send the data to the API.
   */
  $scope.handleApply = () => {
    $scope.loading = true
    const selectedGroupsIds = $scope.selectedGroups

    const info = $scope.data.users.map(user => {
      const userObj = {
        id: user.id,
        groups: user.groups && user.groups.length ? user.groups.map(group => group.id) : []
      }

      selectedGroupsIds.forEach(group => {
        const selectedIndex = userObj.groups.findIndex(id => id === group)

        if (selectedIndex === -1) {
          userObj.groups.push(group)
        }
      })

      return userObj
    })

    AdminService.changeUsersGroups(info)
      .then(() => {
        $scope.groupInput.search = ''
        ToastService.showSuccessToast($translate.instant('successTitle'))
        $scope.flags.showSuccessToast = true
        $rootScope.$broadcast('users.reloadAllUsers', true)
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('error'))
      })
      .finally(() => {
        $scope.loading = false
      })

    $scope.closeModal()
  }

  /**
   *  @param {object} inputEvent - event object
   *  @description this method searches for the inputed group names
   */
  $scope.groupSearchInput = inputEvent => {
    $scope.flags.loading = true
    $scope.flags.skip = null
    $scope.groupInput.search = inputEvent.detail.value
    api._loadDataGroups($scope.groupInput.search, false)
  }

  /**
   *  @description this method closes the modal and handles the modal flag.
   */

  $scope.closeModal = () => {
    $scope.returnData = {}
    $scope.close($scope.returnData)
  }

  $scope.scrollShowMore = api._getShowMore

  /**
   *  @param {object} search - Object with search input
   *  @param {boolean} loadMore - if true, load more groups
   *  @description - Load groups from API
   */
  function _loadDataGroups (search, loadMore, skip) {
    $scope.flags.skip = skip !== undefined ? skip : $scope.flags.skip

    GroupService.getGroups($scope.flags.top, $scope.flags.skip, { searchTerm: search })
      .then(response => {
        api._successGetDataGroups(response, loadMore)
      })
      .catch(api._errorGetDataGroups)
  }

  /**
   *  @param {object} response - response from server
   *  @param {boolean} loadMore - if true, merge groupsList with response.data
   *  @description - Success callback for getGroups
   */
  function _successGetDataGroups (response, loadMore) {
    $scope.flags.noResults = false

    const { results, __count } = response.d

    results.forEach(group => {
      api._handleGroupInitialSelection(group)
    })

    if (loadMore) {
      api._mergeGroupsList($scope.groupsList, results)
    } else {
      $scope.groupsList = results
    }

    $scope.countGroups = __count

    $timeout(api._initObserverShowMore, 500, false)

    $scope.flags.hasShowMoreButton = api._hasMoreResults(__count, $scope.groupsList.length)

    if (!$scope.groupsList.length) {
      $scope.flags.loading = false
      $scope.flags.noResults = true
      return
    }

    $scope.flags.loadingShowMore = false
    $scope.flags.loading = false
  }

  /**
   *  @description - Error callback for getGroups
   */
  function _errorGetDataGroups () {
    ToastService.showErrorToast($translate.instant('error'))
    $scope.flags.loading = false
    $scope.flags.loadingShowMore = false
    $scope.flags.noResults = true
  }

  /**
   *  @param {Number} totalCount - total count of groups
   *  @param {Number} responseLength - total count of array of groups in response
   */
  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return totalCount > responseLength
  }

  /**
   *  @description this method get the next page of groups
   */
  function _getShowMore () {
    $scope.flags.loadingShowMore = true
    $scope.flags.skip = $scope.flags.top + $scope.flags.skip
    api._loadDataGroups($scope.groupInput.search, true)
  }

  /**
   *  @typedef {Array} ArrayList
   *  @param {ArrayList} firstArray - items that will be first in the new array of groups
   *  @param {ArrayList} lastArray - items that will be last in the new array of groups
   *  @description this method merge two arrays and create a new array, only serve to merge the array of groups
   */
  function _mergeGroupsList (firstArray, lastArray) {
    const updatedList = lastArray.map(api._checkGroupAlreadyExistsInArray).filter(Boolean)
    $scope.groupsList = [...firstArray, ...updatedList]
  }

  /**
   *  @param {object} group - object of group
   *  @description this method check if the group already exists in the array of groups
   */
  function _checkGroupAlreadyExistsInArray (group) {
    const index = $scope.groupsList.findIndex(selectedGroup => api._checkEqualGroupId(selectedGroup, group))
    if (index === -1) {
      return group
    }
  }

  /**
   *  @param {object} selectedGroup - object of group
   *  @param {object} group - object of selectedGroup
   *  @description this method checks if the selectedGroup is equal to the group
   */
  function _checkEqualGroupId (selectedGroup, group) {
    return selectedGroup === group.id
  }

  /**
   *  @description this method initializes the group list with the selected/partial groups
   */
  function _initializeGroupList () {
    $scope.groupsList = []
    $scope.selectedGroups = []
    $scope.partialGroups = []
    $scope.countGroups = 0
    $scope.flags.skip = null

    $timeout(api._initObserverShowMore, 500, false)

    api._checkForCommonGroups()

    $scope.groupsList.forEach(group => {
      api._handleGroupInitialSelection(group)
    })

    $timeout(
      () => {
        $scope.flags.hasShowMoreButton = api._hasMoreResults($scope.countGroups, $scope.groupsList.length)
      },
      0,
      true
    )
  }

  /**
   *  @param {object} group - object of group
   *  @param {object} isPartial - boolean
   *  @description this method selects the group and adds it to selectedGroups.
   */
  function _selectGroup (group, isPartial) {
    group.checked = true
    group.partial = false

    if (isPartial) {
      const newPartialArray = $scope.partialGroups.filter(partialGroup => partialGroup !== group.id)
      $scope.partialGroups = newPartialArray
    }

    $scope.selectedGroups.push(group.id)
  }

  /**
   *  @param {object} group - object of group
   *  @description this method "unselects" the group, removing it from selectedGroups and removing from the user groups.
   */
  function _unselectGroup (group) {
    const newArray = $scope.selectedGroups.filter(selectedGroup => selectedGroup !== group.id)

    $scope.selectedGroups = newArray

    $scope.data.users.forEach(user => {
      user.groups = user.groups.filter(item => item.id !== group.id)
    })

    group.checked = false
    group.partial = false
  }

  /**
   *  @param {object} group - object of group
   *  @description this method handles the initial selection of a group.
   */
  function _handleGroupInitialSelection (group) {
    const isSelected = $scope.selectedGroups.some(id => id === group.id)
    const isPartial = $scope.partialGroups.some(id => id === group.id)

    $timeout(
      () => {
        if (isSelected) {
          group.checked = true
          group.partial = false
        } else if (isPartial) {
          group.checked = false
          group.partial = true
        } else {
          group.checked = false
          group.partial = false
        }
      },
      0,
      true
    )
  }

  /**
   *  @description this method handles the user groups, splitting them into partial and selected groups.
   */
  function _checkForCommonGroups () {
    let commonGroups = []
    const partialGroups = []
    const itemGroups = $scope.data.users.map(item => item.groups)
    const itemGroupsIds = []

    itemGroups.forEach(item => {
      const ids = item.map(group => group.id)
      itemGroupsIds.push(ids)
    })

    const firstGroup = itemGroupsIds[0]

    if (itemGroupsIds.length === 1) {
      commonGroups = [...firstGroup]
    } else {
      for (let i = 1; i < itemGroupsIds.length; i++) {
        const firstCommon = firstGroup.filter(item => itemGroupsIds[i].includes(item))

        if (!commonGroups.length && i === 1) {
          commonGroups = [...firstCommon]
        } else {
          const restCommon = commonGroups.filter(item => firstCommon.includes(item))
          commonGroups = [...restCommon]
        }
      }
    }

    itemGroupsIds.forEach(groups => {
      groups.forEach(groupId => {
        const index = commonGroups.findIndex(item => item === groupId)
        const index2 = partialGroups.findIndex(item => item === groupId)

        if (index === -1 && index2 === -1) {
          partialGroups.push(groupId)
        }
      })
    })

    $scope.partialGroups = partialGroups

    $scope.selectedGroups = commonGroups
  }
}

export { AddToGroupsDialogController }
